import { STACKED_BAR_CHART_BAR_COLORS } from '@/pages/ui/stacked-bar-chart/constants'
import type { StackedBarChartSegmentData } from '@/pages/ui/stacked-bar-chart/types'

import { cn } from '@/lib/utils'

interface Props {
  data: StackedBarChartSegmentData[]
  width?: number
}

export const CaseStatusBreakdownLegend: React.FC<Props> = ({ data, width }) => {
  return (
    <div className={cn('flex flex-wrap justify-center gap-x-4 gap-y-1.5')} style={{ width }}>
      {data.map((x, i) => {
        const color = STACKED_BAR_CHART_BAR_COLORS[i % STACKED_BAR_CHART_BAR_COLORS.length]

        return (
          <div key={x.name} className={cn('flex items-center')}>
            <div className={cn('mr-[6px] size-[12px] rounded-full')} style={{ backgroundColor: color }} />
            <div className={cn('mr-[9px] text-[12px] leading-[22px] text-[#555555]')}>{x.name}</div>
          </div>
        )
      })}
    </div>
  )
}
